import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import * as BeMaccaferriIdentityHelper from '../../api/identity/BeMaccaferriIdentityHelper';
import { ERole } from '../../shared/enum';
import { isDevelopmentEnv, isProductionEnv } from '../../utils/utils';
import { IUser } from '../../shared/iUser';

const initialState: IInitialState<IUser> = {
    initialState: true,
};


export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchUser.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.data = action.payload;
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            })
            .addCase(fetchLogout.fulfilled, state => {
                state.data = undefined;
                state.pending = false;
                state.error = undefined;
                state.initialState = true;
            });
    },
});

export const fetchUser = createAsyncThunk('Identity/GetUser', async (_undefined, { rejectWithValue }) => {
    let user: IUser;
    try {
        if (isProductionEnv() || isDevelopmentEnv()) {
            const res = await BeMaccaferriIdentityHelper.getUserNameAsync();
            user = {
                lastName: res.data.lastName,
                firstName: res.data.firstName,
                email: res.data.email,
                isAdmin: res.data.role == ERole.Admin,
            };
        } else {
            user = {
                lastName: '',
                firstName: 'development user',
                email: 'developmentUser@email.com',
                isAdmin: true,
            };
        }
        return user;
    } catch (error: any) {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            window.location.href = process.env.REACT_APP_EDESIGN_PORTAL_URL ?? '';
        }
        return rejectWithValue(error.response);
    }
});

export const fetchLogout = createAsyncThunk('Identity/Logout', async (_undefined, { rejectWithValue }) => {
    try {
        await BeMaccaferriIdentityHelper.logoutAsync();
    } catch (error: any) {
        return rejectWithValue(error.response);
    }
});

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
